<template>
  <section class="content">
      Proccesing...
  </section>
</template>

<script>
  import MainLayout from '../layouts/Main.vue';
  import axios from 'axios';
  import VueScrollTo from 'vue-scrollto';

  var APIbase = "https://yard-bands.herokuapp.com";

  export default {
    components: {
      MainLayout
    },
    created() {
        this.postPayment();
    },
    destroyed() {
      window.removeEventListener('resize', this.windowResized);
    },
    data() {
      return {
        userName: '',
        instrument: '',
        auditionType: '',
        deal_id: '',
        hour: '',
        day: '',
        email: ''
      };
    },
    methods: {
      postPayment() {
        // Retrieve deal ID from localStorage
        const userId = localStorage.getItem('userId');
        var site = localStorage.getItem('site');

        if (site != 'center' && site != 'north') {
          site = 'center';
        }

        if (!userId) {
          console.error('No user_id found in localStorage');
           window.location = 'https://yardbands.com/thankyoutelaviv';
          return;
        }
        axios.post(`${APIbase}/v2/payment_sumit`, {
          'user_id': userId,
          'site': site
        }).then(response => {
          
          try {
            gtag('event', 'conversion', {
              'send_to': 'AW-864508926/7M9VCPOVinwQ_rednAM',
              'value': 185.0,
              'currency': 'ILS'
            });
          } catch (err) {
            console.error('Error triggering gtag event:', err);
          }
          try {
            fbq('track', 'Purchase', { value: '185.00', currency: 'ILS' });
          } catch (err) {
            console.error('Error triggering fbq event:', err);
          }

          if (site == "north") {
            window.location = 'https://yardbands.com/thankyouhaifa';
          }
          else {
            window.location = 'https://yardbands.com/thankyoutelaviv';
          }
         
          
        }).catch(error => {
          console.error('Error fetching user details:', error);
        });

        this.$forceUpdate();
      },
      getDealDetails() {
        // Retrieve deal ID from localStorage
        const dealNumber = localStorage.getItem('internaldealnumber');
        
        if (!dealNumber) {
          console.error('No deal number found in localStorage');
           window.location = 'https://yardbands.com/rhyaudition';
          return;
        }

        axios.post(`${APIbase}/get_user_by_payment_id`, {
          'deal_id': dealNumber
        }).then(response => {
          this.userName = response.data.name;
          this.instrument = response.data.instrument;
          
          if (response.data.update_source === "website") {
            try {
              gtag('event', 'conversion', {
                'send_to': 'AW-864508926/7M9VCPOVinwQ_rednAM',
                'value': 185.0,
                'currency': 'ILS'
              });
            } catch (err) {
              console.error('Error triggering gtag event:', err);
            }

            try {
              fbq('track', 'Purchase', { value: '185.00', currency: 'ILS' });
            } catch (err) {
              console.error('Error triggering fbq event:', err);
            }
          }

          if (response.data.audition_type === 'Rhythm') {
            window.location = 'https://yardbands.com/rhyaudition';
          } else {
            window.location = 'http://yardbands.com/ensaudition';
          }
          })

        this.$forceUpdate();
      },
      scrollToHome() {
        window.location.href = 'http://dev.backyardbands.co.il';
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Payment.vue?1037ad4a